import { render, staticRenderFns } from "./RekananDetail.vue?vue&type=template&id=0e1155a7"
import script from "./RekananDetail.vue?vue&type=script&lang=js"
export * from "./RekananDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports